/* §3.2 dummy AC meta — combines the parsed Excel meta with hand-curated parent groupings
 * and direction flags from the TRD. Parsed meta lives in supplyAcMeta.json; this file
 * overlays the TRD's parent / direction / prepaid / cod attributes that the Excel doesn't carry.
 */
import parsedAcMeta from './supplyAcMeta.json';

// Overlay: parent grouping, prepaid/COD eligibility, direction. Values from §3.2 of the TRD.
const OVERLAY = {
  // Blue Dart
  BD_DartPlusPrepaid: { parent: 'Blue Dart', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  BD_AirEtailPrepaid: { parent: 'Blue Dart', prepaid: 1, cod: 1, direction: 'Forward', mode: 'AIR' },
  // DTDC
  DTDC_SURFACE:        { parent: 'DTDC', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  'DTDC Air':          { parent: 'DTDC', prepaid: 1, cod: 1, direction: 'Forward', mode: 'AIR' },
  DTDC_Air_Enterprise: { parent: 'DTDC', prepaid: 1, cod: 1, direction: 'Forward', mode: 'AIR' },
  // ATS
  'Amazon Transportation Services': { parent: 'ATS', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  // Shadowfax
  Shadowfax_Matketplace: { parent: 'Shadowfax', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Shadowfax_Flat:        { parent: 'Shadowfax', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Shadowfax_NDD_Heavy:   { parent: 'Shadowfax', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
  Shadowfax_SDD:         { parent: 'Shadowfax', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SDD' },
  Shadowfax_Express:     { parent: 'Shadowfax', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
  Shadowfax_Reverse:     { parent: 'Shadowfax', prepaid: 1, cod: 0, direction: 'Reverse', mode: 'RVP' },
  Shadowfax_Reverse_750: { parent: 'Shadowfax', prepaid: 1, cod: 0, direction: 'Reverse', mode: 'RVP' },
  // Delhivery
  'Delhivery SURFACE':      { parent: 'Delhivery', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Delhivery_ENT_SURFACE:    { parent: 'Delhivery', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Delhivery_WH_SURFACE:     { parent: 'Delhivery', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  'Delhivery BULK-B2C':     { parent: 'Delhivery', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  'Delhivery EXPRESS':      { parent: 'Delhivery', prepaid: 1, cod: 1, direction: 'Forward', mode: 'AIR' },
  Delhivery_Reverse:        { parent: 'Delhivery', prepaid: 1, cod: 0, direction: 'Reverse', mode: 'RVP' },
  // Ekart
  Ekart:            { parent: 'Ekart', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Ekart_Heavy_B2C:  { parent: 'Ekart', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Ekart_Priority:   { parent: 'Ekart', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  Ekart_Air:        { parent: 'Ekart', prepaid: 1, cod: 1, direction: 'Forward', mode: 'AIR' },
  // Xpressbees
  XpressBees:             { parent: 'Xpressbees', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  XpressBees_2kg:         { parent: 'Xpressbees', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SURFACE' },
  XpressBees_Air:         { parent: 'Xpressbees', prepaid: 1, cod: 1, direction: 'Forward', mode: 'AIR' },
  XpressBees_SDD:         { parent: 'Xpressbees', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SDD' },
  XpressBees_NDD:         { parent: 'Xpressbees', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
  XpressBees_Reverse:     { parent: 'Xpressbees', prepaid: 1, cod: 0, direction: 'Reverse', mode: 'RVP' },
  XpressBees_Reverse_750: { parent: 'Xpressbees', prepaid: 1, cod: 0, direction: 'Reverse', mode: 'RVP' },
  // Blitz
  Blitz:     { parent: 'Blitz', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
  Blitz_SDD: { parent: 'Blitz', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SDD' },
  // ElasticRun
  'ElasticRun SDD': { parent: 'ElasticRun', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SDD' },
  ElasticRun_2Kg:   { parent: 'ElasticRun', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
  // Tezz
  Tezz_SDD_NDD: { parent: 'Tezz', prepaid: 1, cod: 1, direction: 'Forward', mode: 'SDD' },
  // Pikndel
  Pikndel_Enterprise_NDD: { parent: 'Pikndel', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
  Pikndel_NDD_Heavy:      { parent: 'Pikndel', prepaid: 1, cod: 1, direction: 'Forward', mode: 'NDD' },
};

// Merge parsed Excel meta + TRD overlay. AC names exclusive to the Excel get sensible defaults.
function deriveParent(ac) {
  const lower = ac.toLowerCase();
  if (lower.startsWith('bd_')) return 'Blue Dart';
  if (lower.startsWith('dtdc')) return 'DTDC';
  if (lower.startsWith('delhivery')) return 'Delhivery';
  if (lower.startsWith('xpressbees')) return 'Xpressbees';
  if (lower.startsWith('shadowfax')) return 'Shadowfax';
  if (lower.startsWith('ekart')) return 'Ekart';
  if (lower.startsWith('elasticrun')) return 'ElasticRun';
  if (lower.startsWith('pikndel')) return 'Pikndel';
  if (lower.startsWith('blitz')) return 'Blitz';
  if (lower.startsWith('tezz')) return 'Tezz';
  if (lower.includes('amazon')) return 'ATS';
  return 'Other';
}

export const AC_META = (() => {
  const result = {};
  const allAcs = new Set([...Object.keys(parsedAcMeta), ...Object.keys(OVERLAY)]);
  for (const ac of allAcs) {
    const parsed = parsedAcMeta[ac] || {};
    const overlay = OVERLAY[ac] || {};
    result[ac] = {
      ac,
      przId: parsed.przId || null,
      codCharge: parsed.codCharge || null,
      rtoCharge: parsed.rtoCharge || null,
      qcCharge: parsed.qcCharge || null,
      parent: overlay.parent || deriveParent(ac),
      mode: overlay.mode || parsed.mode || 'SURFACE',
      direction: overlay.direction || parsed.direction || 'Forward',
      prepaid: overlay.prepaid != null ? overlay.prepaid : 1,
      cod: overlay.cod != null ? overlay.cod : 1,
    };
  }
  return result;
})();

export const PARENT_TO_ACS = (() => {
  const map = {};
  for (const ac of Object.keys(AC_META)) {
    const p = AC_META[ac].parent;
    if (!map[p]) map[p] = [];
    map[p].push(ac);
  }
  return map;
})();

// Derive the list of service-type ids this AC can serve. Mirrors §3.3 logic.
export function deriveAcServiceTypes(ac) {
  const meta = AC_META[ac];
  if (!meta) return [];
  const lower = ac.toLowerCase();
  const large = /(heavy|bulk|_2kg|_5kg)/.test(lower);
  const qc = /(_750|shadowfax_reverse$)/.test(lower);
  const hasNdd = /ndd/i.test(ac);
  const out = [];
  if (meta.direction === 'Reverse') {
    out.push(
      large
        ? (qc ? 'REV_LARGE_QC' : 'REV_LARGE_NOQC')
        : (qc ? 'REV_REG_QC' : 'REV_REG_NOQC'),
    );
  } else if (meta.mode === 'SDD') {
    out.push(large ? 'SDD_FWD_LARGE' : 'SDD_FWD_REG');
    out.push(large ? 'SC_NDD_FWD_LARGE' : 'SC_NDD_FWD_REG');
  } else if (meta.mode === 'NDD') {
    out.push(large ? 'INTERCITY_NDD_LARGE' : 'INTERCITY_NDD_REG');
    out.push(large ? 'SC_NDD_FWD_LARGE' : 'SC_NDD_FWD_REG');
  } else if (meta.mode === 'AIR') {
    out.push(large ? 'FWD_AIR_LARGE' : 'FWD_AIR_REG');
  } else {
    // SURFACE
    if (hasNdd && large) out.push('INTERCITY_NDD_LARGE', 'SC_NDD_FWD_LARGE', 'FWD_SURFACE_LARGE');
    else if (hasNdd) out.push('INTERCITY_NDD_REG', 'SC_NDD_FWD_REG', 'FWD_SURFACE_REG');
    else out.push(large ? 'FWD_SURFACE_LARGE' : 'FWD_SURFACE_REG');
  }
  return out;
}

export const AC_SERVICE_TYPES = (() => {
  const out = {};
  for (const ac of Object.keys(AC_META)) {
    out[ac] = deriveAcServiceTypes(ac);
  }
  return out;
})();
